import { View } from "react-native";
import StyledText from "../../common/ui/styled-text";
import { useBillingSubscriptions } from "../../../hooks/useBilling";
import React from "react";
import SubscriptionItem, {
  SubscriptionItemSkeleton,
} from "./subscriptions/subscription-item";

const Billing = () => {
  const {
    data: subscriptions,
    isLoading,
    isError,
    error,
  } = useBillingSubscriptions();

  if (isError) {
    return (
      <View className="p-2">
        <StyledText className="text-red-500">
          Error loading subscriptions
          {error instanceof Error ? `: ${error.message}` : "."}
        </StyledText>
      </View>
    );
  }

  if (!isLoading && (!subscriptions || subscriptions.length === 0)) {
    return (
      <View className="p-2">
        <StyledText>No subscriptions found.</StyledText>
      </View>
    );
  }

  return (
    <View className="w-full max-w-4xl space-y-6 self-center">
      <View>
        <View className="mb-3">
          <StyledText className="text-2xl font-semibold text-gray-900">
            Subscriptions
          </StyledText>
        </View>
        <View className="-mx-4 sm:mx-0 rounded-md border border-gray-200 overflow-hidden bg-white">
          <View className="flex-row items-center pl-1 pr-4 sm:pl-3 sm:pr-14 py-2 bg-gray-50 border-b border-gray-200 space-x-1 sm:space-x-2">
            <View className="w-[30px]" />
            <View className="min-w-[120px] basis-[200px] shrink">
              <StyledText className="text-[12px] text-gray-600 font-medium">
                Restaurant
              </StyledText>
            </View>
            <View className="hidden sm:flex w-[60px]" />
            {/* Flexible spacer after status to push right columns */}
            <View className="flex-1" />
            <View className="min-w-[100px] basis-[140px] shrink items-end">
              <StyledText className="text-[12px] text-gray-600 font-medium">
                Payment Method
              </StyledText>
            </View>
            <View className="min-w-[80px] w-[100px] items-end">
              <StyledText className="text-[12px] text-gray-600 font-medium text-right">
                Latest Invoice
              </StyledText>
            </View>
          </View>
          {isLoading
            ? [...Array(4)].map((_, idx) => (
                <SubscriptionItemSkeleton key={idx} />
              ))
            : subscriptions!.map((sub) => (
                <SubscriptionItem key={sub.id} sub={sub} />
              ))}
        </View>
      </View>
    </View>
  );
};

export default Billing;
